<div
  class=""
  [ngClass]="{
    'mt-2': isFollowUp,
  }">
  <p
    [ngClass]="{
      'italic text-gray-600': yesNo() === false || yesNo() === true,
      'fault-answer': diagnosticStepType() === 'fault answer',
      'ok-answer': diagnosticStepType() === 'ok answer',
    }">
    {{ cleanQuestion(diagnosticStep?.text) }}
  </p>
  <!-- <p>{{ diagnosticStep?.flashVarsString }} </p> -->
  @if (diagnosticStep?.scopeImagesPaths && (diagnosticStep?.scopeImagesPaths?.length ?? 0) > 0) {
    <div class="flex flex-col gap-2">
      @for (img of diagnosticStep?.scopeImagesPaths; track $index) {
        <img [src]="img" alt="" class="max-h-[300px] w-full max-w-full rounded border border-stone-100 object-none" />
      }
    </div>
  }

  @if (diagnosticStep?.wirediagramLink) {
    <div class="my-4 w-full border border-gray-100 p-2 md:overflow-hidden">
      <app-svg [url]="diagnosticStep?.wirediagramLink" [padding]="6" maxHeight="100%" [withZoom]="true" class="h-full w-full object-contain" />
    </div>
  }

  <!-- Nested further questions -->
  @if (diagnosticStepType() === 'yes/no question') {
    <app-yes-no-buttons [state]="yesNo()" (onYes)="answeredYes()" (onNo)="answeredNo()" class="my-4 block" />

    @if (diagnosticStep?.yesAnswer && yesNo() === true) {
      <app-hp-diagnosis-question
        [diagnosticStep]="diagnosticStep?.yesAnswer"
        (onFinished)="finishStep()"
        [svgComponent]="svgComponent"
        [isLastStep]="isLastStep"
        [isOpened]="true"
        [isFollowUp]="true" />
    }

    @if (diagnosticStep?.noAnswer && yesNo() === false) {
      <app-hp-diagnosis-question
        [diagnosticStep]="diagnosticStep?.noAnswer"
        (onFinished)="finishStep()"
        [svgComponent]="svgComponent"
        [isLastStep]="isLastStep"
        [isFollowUp]="true"
        [isOpened]="true" />
    }
  }

  <!-- Buttons -->
  @if (diagnosticStepType() === 'ok answer' || diagnosticStepType() === 'fault answer' || diagnosticStepType() === 'general') {
    <div class="ml-auto mt-4 flex shrink-0 flex-wrap justify-end">
      <p-button severity="info" size="small" (onClick)="finishStep()">
        @if (isLastStep && !hasMoreQuestions()) {
          {{ 'diagnosis.finishDiagnosis' | transloco }}
        } @else {
          {{ 'diagnosis.nextStep' | transloco }}
        }
      </p-button>
    </div>
  }
</div>
